"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const consts_1 = require("@opsbase/lib-time/consts");
const createCustomRepetition_1 = __importDefault(require("@opsbase/lib-time/helpers/createCustomRepetition"));
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class OpScheduleModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.whenCanView = consts_1.DEFAULT_WHENCANVIEW;
        this.whenCanStart = consts_1.DEFAULT_WHENCANSTART;
        this.whenIsMissed = consts_1.DEFAULT_WHENMISSED;
        this.allPlacesPermitted = false;
        this.placesSelectedByTag = false;
        this.placesSelectedByParent = false;
        this.repetitionType = RepetitionType_1.default.WEEKLY;
        this.customRepetition = (0, createCustomRepetition_1.default)();
        this.placeTags = [];
        this.places = [];
        super.init(o);
    }
    get __typename() {
        return 'OpSchedule';
    }
    set __typename(v) {
    }
}
exports.OpScheduleModel = OpScheduleModel;
OpScheduleModel.ALL_FIELDS = `
		id,
		opDefinitionId,
		dueDate,
		untilDate,
		whenCanStart,
		whenCanView,
		whenIsMissed,
		allPlacesPermitted,
		placesSelectedByTag,
		placesSelectedByParent,
		places { id, title, timezone },
		placeTags,
		repetitionType,
		customRepetition`;
exports.default = OpScheduleModel;
ModelRegistry_1.default[DataType_1.default.OPSCHEDULE] = OpScheduleModel;
